import React, {useCallback, useMemo, useState} from 'react';
import GoogleButton from 'app/components/authProvider/buttons/GoogleButton';
import AppleButton from 'app/components/authProvider/buttons/AppleButton';
import FacebookButton from 'app/components/authProvider/buttons/FacebookButton';

const FederatedProviderButtons = ({onClickFb, onClickGoogle, onClickApple}) => {
  const [federatedState, setFederatedState] = useState({
    facebookLogin: false,
    googleLogin: true,
    appleLogin: false,
  });
  const initialized = useMemo(() => Object.values(federatedState).every(Boolean), [federatedState]);

  const handleFacebookInit = useCallback(() => {
    setFederatedState((currentState) => ({...currentState, facebookLogin: true}));
  }, [setFederatedState]);

  const handleAppleInit = useCallback(() => {
    setFederatedState((currentState) => ({...currentState, appleLogin: true}));
  }, [setFederatedState]);

  return (
    <>
      <FacebookButton onClick={onClickFb} initialized={initialized} onInitialized={handleFacebookInit} />
      <GoogleButton onClick={onClickGoogle} initialized={initialized} />
      <AppleButton onClick={onClickApple} initialized={initialized} onInitialized={handleAppleInit} />
    </>
  );
};

export {FederatedProviderButtons};
